import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AcceptInvite from "./pages/AcceptInvite";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Members from "./pages/Members";
import Profile from "./pages/Profile";
import Calendar from "./pages/Calendar";
import Tasks from "./pages/Tasks";
import Recipes from "./pages/Recipes";
import Shopping from "./pages/Shopping";
import Messages from "./pages/Messages";
import Photos from "./pages/Photos";
import AIAssistant from "./pages/AIAssistant";
import Contacts from "./pages/Contacts";
import Maintenance from "./pages/Maintenance";
import Tracker from "./pages/Tracker";
import Budget from "./pages/Budget";
import Documents from "./pages/Documents";
import Goals from "./pages/Goals";
import Chores from "./pages/Chores";
import Emergency from "./pages/Emergency";
import Pets from "./pages/Pets";
import Journal from "./pages/Journal";
import Wishlists from "./pages/Wishlists";
import SampleA from "./pages/SampleA";
import SampleB from "./pages/SampleB";
import PublicDigest from "./pages/PublicDigest";
import PublicTopic from "./pages/PublicTopic";
import { registerServiceWorker } from "./lib/push";
import { bootstrapBackgroundTracking } from "./lib/bgLocation";
import InstallPrompt from "./components/InstallPrompt";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--hh-cream)" }}>
        <div className="nb-card p-8" data-testid="loading-spinner">
          <p className="text-lg font-semibold" style={{ fontFamily: "var(--hh-display)" }}>Loading familytable…</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  registerServiceWorker();
  bootstrapBackgroundTracking();
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <InstallPrompt />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/invite/:code" element={<AcceptInvite />} />
            <Route path="/sample-a" element={<SampleA />} />
            <Route path="/sample-b" element={<SampleB />} />
            <Route path="/digest/:token" element={<PublicDigest />} />
            <Route path="/topic/:token" element={<PublicTopic />} />
            <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/members" element={<Members />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/recipes" element={<Recipes />} />
              <Route path="/shopping" element={<Shopping />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/photos" element={<Photos />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/wishlists" element={<Wishlists />} />
              <Route path="/ai" element={<AIAssistant />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/maintenance" element={<Maintenance />} />
              <Route path="/tracker" element={<Tracker />} />
              <Route path="/budget" element={<Budget />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/goals" element={<Goals />} />
              <Route path="/chores" element={<Chores />} />
              <Route path="/emergency" element={<Emergency />} />
              <Route path="/pets" element={<Pets />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
